import React from "react";
import { Flex, Button, Modal } from "@jsq/ds/core";
import { OwnerThresholdWarningModalProps } from "./types";

/**
 * `OwnerThresholdWarningModal` is a React component for the warning modal that lists the subsidiaries that would be affected
 */
export const OwnerThresholdWarningModal: React.FC<OwnerThresholdWarningModalProps> = (
  props: OwnerThresholdWarningModalProps,
) => {
  return (
    <Modal show={props.show} size="small">
      <Modal.Header closeButton onHide={props.onClose}>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {`Changing this answer to "no" will delete the following owners and
          controllers from ${props.parentName} and its subsidiaries:`}
        </p>
        <ul>
          {props.subsidiaries?.map((subsidiary: string, index: number) => (
            <li key={index}>{subsidiary}</li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Flex flexDirection="row" gap="10px" justifyContent="flex-end">
          <Button variant="neutral" onClick={props.onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={props.onContinue}>
            Continue
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  );
};
